
<template>
  <div
    :class="[modelData.isImageModalShown ? 'd-flex ': 'd-none']"
    class="image-modal-wrapper generic-modal position-fixed align-items-center justify-content-center position-fixed">
    <div class="modal-inner  align-items-center justify-content-center d-flex h-100 w-100">
      <div class="bm-modal-content bg-white px-24 pt-20  pb-xl-35 pb-lg-29 pb-md-29 position-fixed rounded rounded-4 pt-xl-26 pt-lg-20" >
        <div
          class="p-0 border-0 text-end close-icon-wrapper custom-icon position-absolute"
          @click="handleModalClose">
          <icon name="close-icon"/>
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <div
            v-if="modelData.message.includes('Success')"
            class="d-flex align-items-center justify-content-center">
            <img
              src="../../assets/icons/tick.png"
              width="50" >
          </div>
          <div
            v-if="modelData.message.includes('Error')"
            class="d-flex align-items-center justify-content-center">
            <img
              src="../../assets/icons/CrossImage.png"
              width="50" >
          </div>

          <p class="text-center modal-heading text-dark-gray fs-20 mb-0">{{ modelData.message }}</p>
          <div class="tabs-wrapper">
            <div class="tabs-inner d-flex justify-content-center "/>
          </div>
        </div>
        <div
          v-if="modelData.request== 'SaveReq' || modelData.request== 'SaveOrderReject' || modelData.request == 'LoadingProductErrorMessage'"
          class="bm-modal-footer mt-30 d-flex justify-content-center align-items-center" >
          <button
            class="lf-btn blue-border-btn action-btn bg-white"
            @click="handleModalClose">Ok</button>
        </div>
        <div
          v-else
          class="bm-modal-footer mt-xl-30 mt-lg-24  mt-md-24 d-flex justify-content-between align-items-center">

          <button
            class="lf-btn blue-border-btn action-btn bg-white"
            @click="handleModalClose">No</button>
          <button
            class="bm-primary-btn action-btn"
            @click.stop="deleteContent">Yes</button>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="handleModalClose"
    />
  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  data() {
    return {
      // isImageModalShown: false,
      isTabClicked:   false,
      selectedId:     '1',
      isGalleryShown: false,
      query:          '',
      isFocused:      false,
      isFocusedOut:   false,
      tempData:       '',
      modelData:      {
        isImageModalShown: false,
        request:           '',
        message:           '',
        data:              null,
        isVideo:           false,
      },

    };
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, this.updateCofirmationModal);
  },


  methods: {
    pdfGeneration() {

    },
    handleTabClick(id) {
      this.selectedId = id;
    },
    handleModalClose() {
      this.$store.commit('setImageModel', false);
      this.modelData.isImageModalShown = !this.modelData.isImageModalShown;
    },

    clearValue() {
      this.query     = '';
      this.isFocused = false;
    },

    typeFocus() {
      if (this.query.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    removeFocus() {
      this.isFocused = false;
    },

    focusIn() {
      this.isFocusedOut = true;
    },

    updateCofirmationModal(temData) {
      this.modelData.isImageModalShown = true;
      if (temData.request == 'DeleteReq') {
        this.modelData.request =  temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data;
        this.modelData.isVideo = temData.isVideo ? temData.isVideo : false;
      } else if (temData.request == 'SaveReq') {
        this.modelData.request =  temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request == 'DeletePageRequest') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data;
      } else if (temData.request == 'SaveOrderReject') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request == 'SaveOrderReject') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request == 'LoadingProductErrorMessage') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request === 'deleteFavouriteSizeFromAPI') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data;
      } else if (temData.request === 'RemoveAudioFromProduct') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      }
    },
    deleteContent() {
      if (this.modelData.request == 'DeleteReq') { EventBus.$emit('deleteContentReq', this.modelData.data); } else if (this.modelData.request == 'DeletePageRequest') {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        EventBus.$emit(ApplicationEventTypes.ProductPageEvents.PAGE_DELETE);
      } else if (this.modelData.request === 'deleteFavouriteSizeFromAPI') {
        EventBus.$emit('deleteFavouriteSize', this.modelData.data.id);
      } else if (this.modelData.request === 'RemoveAudioFromProduct') {
        EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, null);
        EventBus.$emit('unSelectAudioLayer');
        this.$store.commit('activeProduct/UpdateIsAudioTrimOn', false);
        EventBus.$emit('toggleAudioLeftSectionAccordion', false);
      }

      if (this.modelData.isVideo) {
        /* EventBus.$emit(ApplicationEventTypes.ProductPageEvents.ACTIVE_PAGE_DURATION_UPDATE); */
      }

      this.modelData.isImageModalShown = false;
    },
  },
};

</script>
<style  lang="scss">
.generic-modal{
  .bm-modal-content{
    max-height: none !important;
    height: auto;
    width: 30vw !important;
    min-width: 0;

    .bm-modal-footer{
      max-width: 250px;
    }
  }
  .close-icon-wrapper{
    top: 10px;
    right: 10px;
  }
}

@media screen and (max-width: 1285px){
  .bm-modal-content  .fs-20{
    font-size: 18px !important;
  }

}
</style>
